import AddIcon from '@mui/icons-material/Add';
import ErrorIcon from '@mui/icons-material/Error';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import {
  Box,
  Button,
  Container,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Tooltip,
  Typography,
} from '@mui/material';
import { TitleHead } from 'common/components/Widgets';
import type { NextPage } from 'next';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';

import { InfoArea } from '~/components/core';
import { error_handler } from '~/error_handler';
import { OrderSummaryForCustomer as OrderSummary } from '~/generated/api-client/model';
import { listOrdersOrdersGet } from '~/generated/api-client/scan';
import {
  getOrderStatus,
  orderStatusToText,
  orderRequiresCustomerAction,
} from '~/lib/order';

const Home: NextPage = () => {
  const router = useRouter();
  const [orders, setOrders] = useState<OrderSummary[]>([]);

  useEffect(() => {
    listOrdersOrdersGet({ size: 5, order_confirmed: true }) // todo for now
      .then((res) => {
        setOrders(res.items);
      })
      .catch((e) => {
        error_handler(e, router);
      });
  }, [router]);

  return (
    <Container>
      <InfoArea />
      <TitleHead title="マイページ" />
      <Box mt={2} />
      <Paper>
        <Box p={2}>
          <Typography variant="h6" color="primary" gutterBottom>
            最近の注文
          </Typography>

          {orders.length > 0 ? (
            <Table>
              <TableHead>
                <TableCell>注文日</TableCell>
                <TableCell>ステータス</TableCell>
                <TableCell>未返信メッセージ</TableCell>
              </TableHead>
              <TableBody>
                {orders.map((order) => {
                  const orderStatus = getOrderStatus(order);
                  return (
                    <Link
                      key={order.order_id}
                      href={`/orders/${order.order_id}`}
                      passHref
                    >
                      <TableRow key={order.order_id} component={Button}>
                        <TableCell>
                          {order.order_confirmed_at?.toLocaleString()}
                        </TableCell>
                        <TableCell>
                          <Stack direction="row">
                            {orderRequiresCustomerAction(orderStatus) ? (
                              <Tooltip title="お客様のアクションが必要です。">
                                <ErrorIcon color="warning" />
                              </Tooltip>
                            ) : (
                              <></>
                            )}
                            <Box
                              sx={{
                                fontWeight: orderRequiresCustomerAction(
                                  orderStatus
                                )
                                  ? 'bold'
                                  : 'none',
                              }}
                            >
                              {orderStatusToText(orderStatus)}
                            </Box>
                          </Stack>
                        </TableCell>
                        <TableCell>
                          {order.unreplied_message?.message ?? '-'}
                        </TableCell>
                      </TableRow>
                    </Link>
                  );
                })}
              </TableBody>
            </Table>
          ) : (
            <Typography>現在、注文中の3Dモデルはありません。</Typography>
          )}
        </Box>
        <Box p={2}>
          <Stack spacing={2} direction="row">
            <Link href="/orders" passHref>
              <Button variant="contained">
                <ShoppingCartIcon />
                <Box ml={1}>すべての注文</Box>
              </Button>
            </Link>
            <Link href="/orders/new" passHref>
              <Button variant="contained">
                <AddIcon />
                <Box ml={1}>新規注文</Box>
              </Button>
            </Link>
          </Stack>
        </Box>
      </Paper>
    </Container>
  );
};

export default Home;
